// Shared design tokens. Keep the main brand colors here so they can be tweaked
// in a single place instead of being scattered across the styled-components.

export const colors = {
  // brand red (was both `rgb(218, 0, 38)` and `#DA0026` across the codebase)
  primary: "#da0026",
  // darker red used for hover states
  primaryDark: "#ae001e",
  // dark navy used for headers, footer and panels
  dark: "#212c36",
  // muted greys for secondary text
  gray: "#999999",
  grayText: "#4d4d4d",
  // light section background
  lightBg: "#f8f9fa",
  white: "#ffffff",
  black: "#000000",
} as const;

// translucent helpers built on top of the palette
export const overlays = {
  // dark gradient layer used over hero/section background images
  imageDark: "rgba(0, 0, 0, 0.6)",
  imageDarkLight: "rgba(0, 0, 0, 0.5)",
  white60: "rgba(255, 255, 255, 0.6)",
} as const;
